/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Theme props for Widgets components
 *
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.3.0
 */

// Search Accounts
export const widgetSearchAccountsListNumberWidth = '200px';
export const widgetSearchAccountsListBalanceWidth = '200px';
export const widgetSearchAccountsListSubscribersWidth = '200px';
export const widgetSearchAccountsListHeight = '400px';
export const widgetSearchAccountsRowHeight = '40px';
